import type { Axios } from 'axios';
import { TimeTableGateway } from '@/widgets/Wizard/gateways/time-table';
import type { WizardOptions } from '@/widgets/Wizard/models/time-table/wizard-options';
import { BookingAllowedStatus } from '@/widgets/Wizard/models/time-table/status';
import type { Account } from '@/widgets/Wizard/models/accounts';
import { parseTimeTableStatusResponse, parseTimeTableWizardOptionsResponse } from './api/conversion';

export class TimeTableService extends TimeTableGateway {
    constructor(private readonly client: Axios) {
        super();
    }

    public async getBookingStatus(account: Account): Promise<BookingAllowedStatus> {
        try {
            const response = await this.client.get('/api/status');

            return parseTimeTableStatusResponse(response);
        } catch (err) {
            console.warn('Time table API call failed!', err);

            return BookingAllowedStatus.UNSET;
        }
    }

    public async getWizardOptions(account: Account): Promise<WizardOptions | null> {
        if (import.meta.env.DEV && window.location.hostname.includes('localhost')) {
            this.client.defaults.headers.common['X-Referer'] = `https://${account.hosts[0]}/`;
        }

        try {
            const response = await this.client.get('/api/wizard/options');

            return parseTimeTableWizardOptionsResponse(response);
        } catch (err) {
            console.warn('Time table API call failed!', err);

            return null;
        }
    }
}
